var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "legal-links" },
    [
      _vm.accessibilityLink.showAccessibilityLink === true
        ? _c(
            "a",
            {
              key: _vm.accessibilityLink.accessibilityActivate,
              class: _vm.accessibilityLink.accessibilityStyle,
              attrs: {
                onclick: _vm.accessibilityLink.accessibilityOnclick,
                href: _vm.accessibilityLink.accessibilityHref
              }
            },
            [
              _vm._v(
                "\n    " +
                  _vm._s(_vm.accessibilityLink.accessibilityActivate) +
                  "\n  "
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.reducedLegalLinks, function(link) {
        return _c("a", { key: link.name, attrs: { href: link.href } }, [
          _vm._v("\n    " + _vm._s(link.name) + "\n  ")
        ])
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }